import type { FilterValues } from "../components/mobile/types";

const normalizeString = (value?: string | null): string =>
  typeof value === "string" ? value.trim() : "";

const hasNonEmptyStringArray = (
  value?: string | string[] | null
): boolean => {
  if (!value) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.some((item) => normalizeString(item).length > 0);
  }

  return normalizeString(value).length > 0;
};

export const hasActiveFilters = (
  filters?: FilterValues | null
): boolean => {
  if (!filters) {
    return false;
  }

  const {
    primaryLocation,
    dateRange,
    timeRange,
    priority,
    status,
    from_date,
    to_date,
    status_ids,
    priority_ids,
    priority_flag,
    location_id,
    location_barcode,
  } = filters;

  const primaryLocationApplied = normalizeString(primaryLocation).length > 0;

  const dateRangeApplied = Array.isArray(dateRange) && dateRange.length > 0;
  const timeRangeApplied = Array.isArray(timeRange) && timeRange.length > 0;
  const explicitDateApplied = Boolean(from_date || to_date);

  const statusApplied = hasNonEmptyStringArray(status);
  const priorityApplied = hasNonEmptyStringArray(priority);

  const statusIdsApplied = Array.isArray(status_ids) && status_ids.length > 0;
  const priorityIdsApplied =
    Array.isArray(priority_ids) && priority_ids.length > 0;

  const priorityFlagApplied = Array.isArray(priority_flag)
    ? priority_flag.length > 0
    : priority_flag !== undefined;

  const locationApplied =
    (typeof location_id === "number" && !Number.isNaN(location_id)) ||
    normalizeString(location_barcode).length > 0;

  return (
    primaryLocationApplied ||
    dateRangeApplied ||
    timeRangeApplied ||
    explicitDateApplied ||
    statusApplied ||
    priorityApplied ||
    statusIdsApplied ||
    priorityIdsApplied ||
    priorityFlagApplied ||
    locationApplied
  );
};


